import { MSG_REQUIRED } from "../../../helpers/validator-helper";
import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  user: Yup.string().required(MSG_REQUIRED),
  password: Yup.string().required(MSG_REQUIRED),
  params: Yup.object().nullable().notRequired(),
  session: Yup.object().nullable().notRequired(),
});
